import { trpc } from '../../config/trpc';

/**
 * Create / update / delete mutations for shipment forms. Each invalidates the
 * getShipmentFormsByRequestId cache so the Paperwork section reflects changes
 * immediately.
 */
export const useShipmentFormMutations = () => {
  const utils = trpc.useUtils();
  const invalidate = () => utils.getShipmentFormsByRequestId.invalidate();

  const create = trpc.createShipmentForm.useMutation({ onSuccess: invalidate });
  const update = trpc.updateShipmentForm.useMutation({ onSuccess: invalidate });
  const remove = trpc.deleteShipmentForm.useMutation({ onSuccess: invalidate });

  // CargoWise (TMS): pull reconciles our DB from CargoWise, push sends our state
  // out, sync does pull-then-push. All invalidate so integration state refreshes.
  const pull = trpc.pullShipmentForm.useMutation({ onSuccess: invalidate });
  const push = trpc.pushShipmentForm.useMutation({ onSuccess: invalidate });
  const sync = trpc.syncShipmentForm.useMutation({ onSuccess: invalidate });

  return {
    createShipmentForm: create.mutateAsync,
    updateShipmentForm: update.mutateAsync,
    deleteShipmentForm: remove.mutateAsync,
    pullShipmentForm: pull.mutateAsync,
    pushShipmentForm: push.mutateAsync,
    syncShipmentForm: sync.mutateAsync,
    isCreating: create.isLoading,
    isDeleting: remove.isLoading,
    isPulling: pull.isLoading,
    isPushing: push.isLoading,
    isSyncing: sync.isLoading,
  };
};
